module.exports = __webpack_public_path__ + "img/1280x720-Autumn.2b7998a5.jpg";